<!-- modal-header -->
<div class="modal-header bg-primary text-white details-modal-header">
  <h5 class="modal-title text-white details-modal-title">Alert Information</h5>
  <button
    type="button"
    class="btn-close btn-close-white"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  ></button>
</div>

<!-- modal-body -->
<div class="modal-body details-modal-body">
  <div class="card shadow-sm">
    <!-- Header Section -->
    <div>
      <div class="d-flex justify-content-between align-items-center px-3 py-2 bg-primary text-white">
        <span>{{alertInfo.name}}</span>
        @if (alertInfo.status === 'active') {
          <i class="fa fa-trash" (click)="dismissAlert(alertInfo.id)" title="Dismiss Alert"></i>
        }
      </div>

      <!-- Bootstrap Tabs -->
      <ul class="nav nav-tabs px-2 py-2 userdetail-custom-tab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link" [class.active]="activeTab === 'basic'" (click)="setTab('basic')" type="button">Details</button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" [class.active]="activeTab === 'photo'" (click)="setTab('sop')" type="button">SOP</button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" [class.active]="activeTab === 'emergency'" (click)="setTab('floor')" type="button">Floor</button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" [class.active]="activeTab === 'medical'" (click)="setTab('attachment')" type="button">Attachment</button>
        </li>

      </ul>

      <!-- Tab Content -->
      <div class="tab-content p-2 bg-light">
        <!-- Basic Info -->
        @if (activeTab === 'basic') {
          <div>
            <p class="modal_p"><strong>Description:</strong> {{description}}</p>
            <p class="modal_p"><strong>Time:</strong> {{time}} </p>
            <p class="modal_p"><strong>Activated Sensor:</strong> None </p>
            <p class="modal_p"><strong>Sender:</strong> System </p>
            <p class="modal_p" (click)="checkSuspect(number,true,true)"><strong>Suspect:</strong> {{name}}  <i class="fas fa-circle-info me-3"></i></p>
            <hr />
            <div class="row">
              <div class="col-8">
                <p class="modal_p"><strong>Building:</strong> {{building}}</p>
                <p class="modal_p"><strong>Floor:</strong> {{floor}}</p>
                <p class="modal_p"><strong>Room:</strong> {{room}}</p>
              </div>
              <div class="col-3">
                @if (alertInfo.status === 'active') {
                  <button  style="width: 40px;" type="button" class="btn btn-danger" (click)="createIncident(this.alertInfo?.buildingInfo?.[0])" title="create incident">
                    <i class="fa fa-bolt"></i>
                  </button>
                }
              </div>
            </div>
          </div>
        }

        <!-- Photo -->
        @if (activeTab === 'sop') {
          <div>
            @if (sopname && sopname.trim().length > 0) {
              <div class="mb-1 font-weight-bold">
                <h6 class="modal_p">SOP: <strong>{{ sopname }}</strong></h6>
              </div>
              <div class="table-responsive">
                <table class="table table-bordered table-hover custom-table">
                  <thead class="thead-light">
                    <tr>
                      <th>#</th>
                      <th>SOP Step</th>
                      <th>Info</th>
                      <th>Time</th>
                      <th>Completed</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-dark">1</td>
                      <td class="text-dark">{{ sopname }}</td>
                      <td class="text-center">
                        <i class="fa fa-info-circle text-info" title="Sound the evacuation alarm"
                        (click)="sopDetails(sopInfo, true)"></i>
                      </td>
                      <td class="text-dark">{{ datetime | date:'medium' }}</td>
                      <td class="text-dark">No</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            } @else {
              <p class="text-danger">SOP Data not found</p>
            }
          </div>
        }


        <!-- Emergency Contact -->
        @if (activeTab === 'floor') {
          <div>
            <div>
              <span><strong>Floor:  </strong></span>
              @if (building) {
                <span class="fs-6"><strong> Building:</strong> <span style="color: #aaa">{{building}}</span></span>
              }
              @if (floor) {
                <span class="fs-6"><strong> Floor:</strong> <span style="color: #aaa">{{floor}}</span></span>
              }
              @if (room) {
                <span class="fs-6"><strong> Room:</strong> <span style="color: #aaa">{{room}}</span></span>
              }
            </div>
            <div id="floor-map-monitor-card" style="width: 100%; height: 300px; overflow: hidden;"></div>
          </div>
        }

        <!-- Medical Info -->
        @if (activeTab === 'attachment') {
          <div>
            <p><strong>Attachment:</strong></p>
          </div>
        }

        <!-- Last 5 Activity -->

      </div>
    </div>


  </div>


</div>
